export default class MainProduct {
    constructor() {
        this.section = document.querySelector(".no-main-prod");
        if (!this.section) return;

        this.init();
    }

    init() {
        this.items = this.section.querySelectorAll(".no-main-prod__item");

        this.initProductAnimation();
    }

    initProductAnimation() {
        if (!this.items.length) return;

        // 초기 상태 일괄 설정 (GPU 가속)
        gsap.set(this.items, {
            scale: 0.5,
            opacity: 0,
            y: 50,
            force3D: true,
        });

        // 하나의 타임라인으로 통합하여 성능 향상
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.section,
                start: "top 60%",
                end: "center center",
                toggleActions: "play none none reverse",
            },
        });

        // 각 아이템 순차적 애니메이션 추가
        this.items.forEach((item, index) => {
            tl.to(
                item,
                {
                    scale: 1,
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: "back.out(1.2)",
                    force3D: true,
                },
                index * 0.05 // 시작 시간 오프셋
            );
        });

        // 전체 그리드 스케일 (별도 scrub 애니메이션)
        gsap.fromTo(
            this.section.querySelector(".no-main-prod__grid"),
            {
                scale: 0.95,
                force3D: true,
            },
            {
                scale: 1,
                ease: "none",
                force3D: true,
                scrollTrigger: {
                    trigger: this.section,
                    start: "top 60%",
                    end: "center center",
                    scrub: 0.5,
                },
            }
        );
    }
}
